/**
 * Filtro de vários vendedores em Vendas (cartão do Pedro, 28/10/2026), só do
 * super admin. A seleção mora na URL como lista de ids ("79,80,81"); um id
 * só continua funcionando como antes (?vendedor=79).
 *
 * Equipe = o gestor e quem tem ele em users.manager_id, calculada na hora: mudou
 * o gestor no cadastro, mudou a equipe. Os atalhos são os das equipes de venda
 * pedidas (Lucas e Márcio); gestor que não existe no ambiente não vira atalho.
 */

export type UsuarioFiltro = { id: number | string; name: string; manager_id?: number | string | null };

/** 79 = LUCAS APOLINARIO WEISS, 96 = MARCIO SILVA (ids do PROD). */
export const GESTORES_COM_ATALHO = [
  { gestorId: 79, rotulo: "Equipe Lucas" },
  { gestorId: 96, rotulo: "Equipe Márcio" },
];

export const lerSelecao = (valor: string | null | undefined): number[] =>
  !valor || valor === "all"
    ? []
    : [...new Set(valor.split(",").map((v) => Number(v.trim())).filter((n) => Number.isInteger(n) && n > 0))];

export const gravarSelecao = (ids: number[]): string =>
  ids.length === 0 ? "all" : [...new Set(ids)].sort((a, b) => a - b).join(",");

/** O gestor e todos que respondem a ele. */
export const equipeDe = (gestorId: number, usuarios: UsuarioFiltro[]): number[] => [
  gestorId,
  ...usuarios.filter((u) => Number(u.manager_id) === gestorId).map((u) => Number(u.id)),
];

export const atalhosDeEquipe = (usuarios: UsuarioFiltro[]) =>
  GESTORES_COM_ATALHO.flatMap(({ gestorId, rotulo }) =>
    usuarios.some((u) => Number(u.id) === gestorId) ? [{ gestorId, rotulo, ids: equipeDe(gestorId, usuarios) }] : [],
  );

const mesmoConjunto = (a: number[], b: number[]) => {
  const sa = new Set(a);
  return sa.size === new Set(b).size && b.every((x) => sa.has(x));
};

/** O que o campo fechado mostra. */
export const rotuloDaSelecao = (ids: number[], usuarios: UsuarioFiltro[]): string => {
  if (ids.length === 0) return "Todos os vendedores";
  const equipe = atalhosDeEquipe(usuarios).find((a) => mesmoConjunto(a.ids, ids));
  if (equipe) return equipe.rotulo;
  if (ids.length === 1) return usuarios.find((u) => Number(u.id) === ids[0])?.name ?? "1 vendedor";
  return `${ids.length} vendedores selecionados`;
};

/** Pedaço do filtro da lista: um id = sales_person_id; vários = sales_person_ids. */
export const fragmentoDeVendedores = (ids: number[]) =>
  ids.length === 0 ? {} : ids.length === 1 ? { sales_person_id: String(ids[0]) } : { sales_person_ids: ids };
